export const FACEBOOK = "facebook";
export const TWITTER = "twitter";
export const GOOGLE = "google";
export const YOUTUBE = "youtube";
export const LINKEDIN = "linkedin";
export const VKONTAKTE = "vkontakte";
export const INSTAGRAM = "instagram";
export const PINTEREST = "pinterest";
export const TIKTOK = "tiktok";
